module.exports = __webpack_public_path__ + "static/img/loginIcon.ad79f53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loginIcon.png
// module id = Wldg
// module chunks = 0